import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-direct-authorization-setting-ab',
  templateUrl: './direct-authorization-setting-ab.component.html',
  styleUrls: ['./direct-authorization-setting-ab.component.scss']
})
export class DirectAuthorizationSettingAbComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
